<template>
    <div>
        <div class="filterBg base-form-div">
            <el-form size="mini" :model="searchForm" label-position="right" label-width="120px" inline>
                <el-form-item label="舰船型号:">
                    <el-input v-model="searchForm.type" placeholder="请输入舰船型号" class="filter-item" clearable
                        @keyup.enter.native="handleFilter" @clear="handleFilter" />
                </el-form-item>
            </el-form>
            <div>
                <el-button class="base-button" type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button>
            </div>
        </div>
        <div class="listTable">
            <div class="margins">
                <span>
                    <el-button class="base-button" size="mini" type="primary" icon="el-icon-plus"
                        @click="addCard">新增</el-button>
                    <el-button class="base-button" size="mini" type="primary" icon="el-icon-download"
                        @click="exportFilterTXT">导出TXT</el-button>
                    <el-button class="base-button" size="mini" type="warning" icon="el-icon-upload" @click="uploadXML">导入XML</el-button>
                </span>
                <span>
                </span>
            </div>
            <YzTable max-height="310px" :afterRequest="afterRequest" :columnApi="columns" :listApi="listArray"
                :searchForm="searchForm" :autoLoad="true" ref="YzTable" />
        </div>
    </div>
</template>
  
<script>
import Add from "./add.vue";
import { getCommonAjax } from "@/api/common"
import uploadXMLCom from "./uploadXML/index.vue"
export default {
    data() {
        return {
            columns: "json/shipType.json?v=2",
            listArray: "/wx/queryTypeList",
            searchForm: {
                page: 1,
                pageSize: 10,
                cardNumber: undefined
            },
        };
    },
    created() {
    },
    mounted() {
        this.$bus.$on("shipType-list", () => {
            this.handleFilter();
        });
    },
    beforeDestroy() {
        this.$bus.$off("shipType-list");
    },
    methods: {
        uploadXML(){
            this.$dialog.open({
                title: "装备字典导入",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "380px",
                    width: "680px",
                },
                content: {
                    type: "vue",
                    subCom: uploadXMLCom,
                    subData: {}
                },
            });
        },
        exportFilterTXT() {
            getCommonAjax("/wx/downloadtxt", {}, "arraybuffer").then(res => {
                this.downloadJsonFile(res, '装备字典数据_' + new Date().getTime() + ".txt")
            }).catch(err => {
                console.error(err);
            });
        },
        downloadJsonFile(data, fileName) {
            var blob = new Blob([data], { type: 'application/octet-stream' });
            var url = URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.download = fileName;
            link.href = url;
            link.click();
            URL.revokeObjectURL(url);
        },
        afterRequest(res) {
            return {
                result: {
                    items: res.result,
                    total: 0
                }
            }
        },
        handleFilter() {
            this.searchForm.page = 1;
            this.$refs["YzTable"].getList(this.searchForm, true);
        },
        addCard() {
            var ins = this.$dialog.getDialog("添加舰船型号");
            if (ins) {
                return;
            }
            this.$dialog.open({
                id: "添加舰船型号",
                title: "添加舰船型号",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "240px",
                    width: "400px",
                },
                content: {
                    type: "vue",
                    subCom: Add
                },
            });
        },
        handleEdit(index, row) {
            console.log(index, row);
        },
    },
};
</script>